// GetSizeSelection returns the size selection with all necessary information.
export const SizeSelectionService_GetSizeSelectionLazy = () =>
  import("./service.grpc").then((m) => m.SizeSelectionService_GetSizeSelection);
SizeSelectionService_GetSizeSelectionLazy.method =
  "aysa_api.services.size_selection.v1.SizeSelectionService/GetSizeSelection" as const;
